module.exports = __webpack_public_path__ + "img/ring_g_o_1_1.07608c44.png";